export default {
  gifts: [],
  giftsCount: 0
}
